import React from 'react';

import { IBdsCircleIndicatorPictogramProps } from '../../../../interfaces/bdsCircleIndicator';
import './BdsCircleIndicatorPictogram.scss';

const BdsCircleIndicatorPictogram = ({
  pictogram,
  className,
  circleIndicatorSize
}: IBdsCircleIndicatorPictogramProps) => {
  const renderIcon = () => {
    if (pictogram.component) {
      return <pictogram.component.component className="bds-circle-indicator-pictogram-icon" />;
    }
    if (pictogram.url) {
      return <img src={pictogram.url} alt="bds-circle-indicator-img" className="bds-circle-indicator-pictogram-icon" />;
    }
    return null;
  };

  const classComponentName = ['bds-circle-indicator-pictogram', className, circleIndicatorSize].join(' ');
  return <div className={classComponentName}>{renderIcon()}</div>;
};

export default BdsCircleIndicatorPictogram;
